import { dateFormats } from "@/utils/dateFormatter";

/**
 * Ferry listing için GA4 ecommerce item'larını oluşturur.
 * GA4 şemasına göre item alanları:
 * - item_id: "Origin-Destination"
 * - item_name: "ferry"
 * - item_brand: sağlayıcı firma
 * - item_category: "ferry"
 * - item_category2: "domestic" | "international"
 * - item_category3: "with_car" | "without_car"
 * - origin / destination: rota şehirleri
 * - start_date / end_date: kalkış / dönüş tarihleri
 * - price: bilet fiyatı
 * - quantity: yolcu sayısına göre adet
 */
export const buildFerryEcommerceItem = ({
  trip,
  index,
  summaryData,
  item_list_id,
  item_list_name,
  withVehicle,
  travelType,
}) => {
  if (!trip) return [];
  const segment = trip?.Segments?.[0] || {};
  const priceSummary = trip?.PriceSummary || {};
  const ticket_type = trip?.ticket_type;

  const originName = segment?.Origin?.split(",")[0] || "";
  const destinationName = segment?.Destination?.split(",")[0] || "";
  const startDateIso = dateFormats.iso(segment?.DepartureDate) || "";
  const endDateIso = dateFormats.iso(segment?.ArrivalDate) || "";
  const baseItem = {
    item_id: `${originName}-${destinationName}`,
    item_name: "ferry",
    affiliation: "turna.com",
    coupon: priceSummary?.AppliedCampaignName || null,
    discount: priceSummary?.DiscountAmount || 0,
    index,
    item_brand: segment?.OperatingCompany || null,
    item_category: "ferry",
    item_category2: travelType?.toLowerCase() || "domestic", // domestic / international
    item_category3: withVehicle ? "with_car" : "without_car",
    ticket_type,
    origin: summaryData?.fromCity || originName,
    destination: summaryData?.toCity || destinationName,
    start_date: startDateIso || "",
    end_date: endDateIso || "",
    item_list_id,
    item_list_name,
    price: priceSummary?.TotalFare || 0,
    quantity: summaryData?.passengerCount || 1,
    currency: priceSummary?.Currency || trip?.Currency || "TRY",
  };

  return [baseItem];
};

/**
 * Verilen ferry listesi için GA4 view_item_list/select_item vb. eventlerinde
 * kullanılacak items array'ini döner.
 */
export const buildFerryEcommerceItems = ({
  trips = [],
  summaryData,
  item_list_id,
  item_list_name,
  withVehicle,
  travelType,
}) => {
  const items = [];

  trips.forEach((trip, idx) => {
    const built = buildFerryEcommerceItem({
      trip,
      index: idx + 1,
      summaryData,
      item_list_id,
      item_list_name,
      withVehicle,
      travelType,
    });
    if (Array.isArray(built) && built.length > 0) {
      items.push(...built);
    }
  });

  return items;
};

/**
 * GA4 gereği view_item_list event'inde her event maksimum 8 item içermeli.
 * Bu helper, items array'ini 8'li gruplara böler.
 */
export const chunkItemsForGa = (items, chunkSize = 8) => {
  if (!Array.isArray(items) || items.length === 0) return [];
  const chunks = [];

  for (let i = 0; i < items.length; i += chunkSize) {
    chunks.push(items.slice(i, i + chunkSize));
  }

  return chunks;
};
